import React from "react";
import styled from "styled-components";

const Container = styled.div<{ $miniMode?: boolean }>`
  height: ${({ $miniMode }) => ($miniMode ? "30px" : "50px")};

  & > svg {
    height: 100%;
    width: auto;
  }
`;

const LogePinPoint = ({ miniMode = false }: { miniMode?: boolean }) => (
  <Container $miniMode={miniMode}>
    <svg
      width="130"
      height="174"
      viewBox="0 0 130 174"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_9017_144758)">
        <path
          d="M6.61043 157.576C6.61043 157.576 16.1344 160.44 22.1582 161.931C27.2123 163.184 34.8948 165.475 38.1658 166.241C41.2178 166.948 49.5386 169.029 51.5716 169.439C55.9996 170.322 63.3067 172.459 65.3886 172.749C65.3886 172.749 65.6475 154.999 65.6377 150.694C65.628 146.389 65.4252 123.96 65.7164 120.395C66.0075 116.831 65.5446 91.9372 65.4884 86.8325C65.4254 80.7184 65.5186 66.6676 65.5061 61.1742C65.502 59.3877 65.9514 38.9227 65.9506 38.5788C65.9506 38.5788 44.8855 35.5002 41.4679 35.0614C38.0503 34.6225 26.6175 32.9513 23.6465 32.5159C20.6755 32.0805 12.9237 30.7538 9.61782 30.3548C7.34389 30.0697 6.31216 30.0542 6.31216 30.0542C6.31216 30.0542 6.22213 57.2981 6.34788 65.4798C6.49037 75.1354 6.16524 112.929 6.31203 118.574C6.43382 123.04 6.2949 140.552 6.4379 142.557C6.54791 143.798 6.61043 157.576 6.61043 157.576Z"
          fill="#F2EEEC"
          stroke="#2C2C2C"
          strokeWidth="0.893234"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M63.1831 38.5851C63.1831 38.5851 42.1136 35.5066 38.7005 35.0677C35.2873 34.6288 23.8501 32.9576 20.8791 32.5222C17.9081 32.0868 9.00414 30.8252 5.71568 30.2297C3.52636 29.8372 0.515386 29.5001 0.515386 29.5001C0.515386 29.5001 9.04043 21.2318 10.9208 19.2936C13.1798 16.9572 19.9694 11.4841 19.9694 11.4841C19.9694 11.4841 27.3932 11.9139 29.0997 12.1333C30.8063 12.3527 40.6162 13.2952 42.7696 13.594C44.923 13.8928 52.9465 14.9108 54.2065 15.1267C55.4664 15.3427 60.9646 15.4821 60.9646 15.4821L67.2815 16.2181C67.2815 16.2181 64.5649 31.4495 64.5659 31.8961C64.5669 32.3427 63.4065 38.598 63.2948 38.5982"
          fill="#FAC55A"
        />
        <path
          d="M63.1831 38.5851C63.1831 38.5851 42.1136 35.5066 38.7005 35.0677C35.2873 34.6288 23.8501 32.9576 20.8791 32.5222C17.9081 32.0868 9.00414 30.8252 5.71568 30.2297C3.52636 29.8372 0.515386 29.5001 0.515386 29.5001C0.515386 29.5001 9.04043 21.2318 10.9208 19.2936C13.1798 16.9572 19.9694 11.4841 19.9694 11.4841C19.9694 11.4841 27.3932 11.9139 29.0997 12.1333C30.8063 12.3527 40.6162 13.2952 42.7696 13.594C44.923 13.8928 52.9465 14.9108 54.2065 15.1267C55.4664 15.3427 60.9646 15.4821 60.9646 15.4821L67.2815 16.2181C67.2815 16.2181 64.5649 31.4495 64.5659 31.8961C64.5669 32.3427 63.4065 38.598 63.2948 38.5982"
          stroke="#2C2C2C"
          strokeWidth="0.893234"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M65.411 172.301C65.411 172.301 65.67 154.552 65.6602 150.247C65.6504 145.941 65.4477 123.513 65.7389 119.948C66.03 116.383 65.5671 91.4899 65.5109 86.3852C65.4479 80.2712 65.541 66.2203 65.5286 60.727C65.5241 58.7485 65.9752 39.0918 65.973 38.1315C65.973 38.1315 93.7718 34.7412 96.0393 34.1822C98.7979 33.506 116.254 30.742 118.062 30.2243C120.151 29.6211 124.984 28.0291 124.984 28.0291C124.984 28.0291 124.525 40.0889 124.716 47.6318C124.883 54.3664 124.646 65.8495 124.767 70.2082C124.889 74.567 124.839 101.989 125.05 106.321C125.191 109.327 124.918 125.079 125.002 128.206C125.085 131.332 124.701 145.437 124.742 147.813C124.778 149.8 124.371 157.519 124.374 158.707C124.377 159.895 65.411 172.301 65.411 172.301Z"
          fill="#FAF8F6"
          stroke="#2C2C2C"
          strokeWidth="0.893234"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M128.309 27.6295C128.309 27.6295 117.471 30.0747 115.364 30.678C113.556 31.1957 96.0998 33.9597 93.3412 34.6358C91.0736 35.1948 63.2749 38.5852 63.2749 38.5852C63.2749 38.5852 65.3568 27.089 65.7093 24.9801L67.2794 16.2184C67.2794 16.2184 69.6904 15.9003 72.6861 15.3888C80.923 13.9901 87.3204 12.8322 92.0697 11.6334C96.819 10.4346 101.128 9.95591 101.721 9.75359C102.315 9.55126 110.332 7.71534 110.332 7.71534C110.332 7.71534 115.987 14.1651 118.889 17.4411C122.323 21.2787 126.405 26.9058 128.309 27.6295Z"
          fill="#FAC55A"
          stroke="#2C2C2C"
          strokeWidth="0.893234"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M60.2951 0.601804C60.2951 0.601804 41.0163 5.29931 39.4317 5.70039C37.8472 6.10148 19.9678 11.4836 19.9678 11.4836C19.9678 11.4836 26.2526 11.8579 32.7569 12.5265C37.8093 13.042 48.7906 14.549 52.8601 14.9194C57.7739 15.3549 66.4269 16.2061 67.2844 16.2042C68.1419 16.2022 77.0706 14.6277 78.7269 14.3337C80.3832 14.0396 92.82 11.3942 94.7976 10.9923C96.7752 10.5903 110.332 7.71456 110.332 7.71456C110.332 7.71456 93.0765 4.35941 90.1723 3.86579C88.5818 3.59696 76.3235 2.25812 74.331 2.0036C72.4994 1.77552 60.2951 0.601804 60.2951 0.601804Z"
          fill="#FAC55A"
          stroke="#2C2C2C"
          strokeWidth="0.893234"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.4665 52.2918L28.5363 52.9771L43.6761 48.7847L38.3285 48.1046L25.4665 52.2918Z"
          fill="white"
          stroke="#2C2C2C"
          strokeWidth="0.893234"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.9742 103.58L28.6495 103.574L28.5347 52.9773L25.4648 52.292L25.9742 103.58Z"
          stroke="#2C2C2C"
          strokeWidth="0.893234"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.6496 103.574L44.5779 98.4871L43.6746 48.785L28.5348 52.9773L28.6496 103.574Z"
          fill="#DC3C31"
          stroke="#2C2C2C"
          strokeWidth="0.893234"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.2843 51.4516L44.0213 52.2495"
          stroke="#2C2C2C"
          strokeWidth="0.893234"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.8259 89.0697L44.5584 89.8721"
          stroke="#2C2C2C"
          strokeWidth="0.893234"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.6754 59.4859L39.6827 62.6703L33.3716 64.4711L33.3712 64.3014L34.1835 64.0673L34.168 57.2207L33.274 56.9056L37.3312 55.7799L36.4398 56.5992L36.4553 63.4279L36.5357 63.4054C37.247 63.1773 37.8701 62.7343 38.3193 62.1375C38.9302 61.3426 39.3968 60.4466 39.6978 59.4903L39.6754 59.4859Z"
          fill="white"
        />
        <path
          d="M32.7656 71.3689C32.7672 70.6489 32.9177 69.9369 33.2075 69.2778C33.5008 68.5865 33.9343 67.9635 34.4806 67.4482C35.0329 66.9224 35.705 66.5391 36.4388 66.3317C37.0823 66.1224 37.773 66.1053 38.4261 66.2825C39.002 66.4496 39.4988 66.8177 39.8264 67.32C40.1873 67.8856 40.3708 68.5462 40.3532 69.2169C40.3493 69.9338 40.199 70.6424 39.9113 71.2991C39.6195 71.9888 39.1874 72.6103 38.6426 73.1242C38.0898 73.6513 37.4182 74.0373 36.6845 74.2497C36.0414 74.4663 35.3489 74.4896 34.6927 74.3167C34.1127 74.1534 33.6118 73.7846 33.2835 73.2793C32.9252 72.708 32.7449 72.043 32.7656 71.3689ZM38.7655 72.1548C38.741 71.3451 38.525 70.5527 38.1349 69.8427C37.7638 69.0933 37.2494 68.4238 36.6209 67.8721C36.0302 67.3732 35.5028 67.1913 35.0342 67.3264C34.8257 67.3833 34.647 67.5179 34.5348 67.7027C34.4048 67.9178 34.3416 68.1666 34.3533 68.4177C34.3767 69.2309 34.5944 70.0268 34.9883 70.7386C35.3601 71.4889 35.8761 72.1585 36.5068 72.7092C37.0975 73.2037 37.6204 73.3856 38.0757 73.2506C38.3012 73.1792 38.4938 73.0295 38.6187 72.8286C38.7435 72.6276 38.7924 72.3886 38.7565 72.1548L38.7655 72.1548Z"
          fill="white"
        />
        <path
          d="M32.9866 81.7912C32.9908 81.0488 33.1512 80.3156 33.4575 79.6393C33.7637 78.963 34.209 78.3587 34.7642 77.8659C35.3502 77.3442 36.045 76.9597 36.7982 76.7403C37.6613 76.4502 38.5858 76.3942 39.4776 76.5779C39.1591 77.9184 39.0042 78.553 38.6901 79.8757C38.2332 79.1483 37.6633 78.4983 37.002 77.9501C36.8149 77.7785 36.5896 77.654 36.3448 77.5869C36.0999 77.5199 35.8426 77.5123 35.5942 77.5648C35.3162 77.6539 35.0842 77.8485 34.9479 78.1067C34.768 78.4393 34.6824 78.8148 34.7002 79.1925C34.7118 79.8543 34.8561 80.507 35.1244 81.112C35.4018 81.7805 35.788 82.3983 36.2674 82.9405C36.6965 83.4492 37.2228 83.8671 37.8155 84.1697L37.8095 81.5347L36.9152 81.0365L39.9322 80.1096L39.9383 82.7893C39.5642 83.2098 39.1372 83.5801 38.6679 83.8909C38.1981 84.2022 37.6856 84.4441 37.1466 84.6089C36.4308 84.865 35.6584 84.9193 34.9139 84.7658C34.3241 84.6206 33.8148 84.2497 33.4957 83.7329C33.1423 83.1483 32.9655 82.474 32.9866 81.7912Z"
          fill="white"
        />
        <path
          d="M36.3761 87.747L36.3837 91.11C36.7505 90.9629 37.0752 90.7274 37.329 90.4245C37.6528 90.0649 37.9118 89.6517 38.0944 89.2035L38.1011 92.1289C37.9304 91.806 37.6648 91.5431 37.3401 91.3758C37.0448 91.2252 36.7042 91.1894 36.3841 91.2753L36.3926 94.9956C37.05 94.7632 37.6409 94.374 38.1139 93.8617C38.7286 93.1705 39.2234 92.3814 39.578 91.527L39.5839 94.1442L33.3358 96.1414L33.3354 95.9717L34.1522 95.7152L34.1366 88.8642L33.2427 88.5759L39.5936 86.6008L39.5996 89.218C39.2636 88.6058 38.7481 88.1114 38.1225 87.8011C37.5656 87.5745 36.9459 87.5553 36.3761 87.747Z"
          fill="white"
        />
        <path
          d="M93.197 147.126L78.2126 150.889L78.1651 129.952C78.1614 127.982 78.8171 126.067 80.0276 124.513C81.2381 122.958 82.9339 121.854 84.8449 121.375L86.2286 121.028C87.0492 120.823 87.9057 120.807 88.7333 120.982C89.5608 121.157 90.3377 121.518 91.0051 122.037C91.6725 122.557 92.2129 123.222 92.5853 123.981C92.9577 124.741 93.1523 125.575 93.1545 126.421L93.197 147.126Z"
          fill="white"
          stroke="#2C2C2C"
          strokeWidth="0.893234"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M114.546 141.909L99.5613 145.664L99.5167 125.981C99.5122 124.011 100.168 122.096 101.378 120.541C102.589 118.987 104.285 117.883 106.196 117.404L107.58 117.057C108.401 116.851 109.258 116.835 110.086 117.01C110.914 117.184 111.692 117.545 112.36 118.065C113.028 118.584 113.569 119.249 113.941 120.009C114.314 120.769 114.509 121.604 114.511 122.45L114.546 141.909Z"
          fill="white"
          stroke="#2C2C2C"
          strokeWidth="0.893234"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M93.1091 109.011L78.1247 112.775L78.0772 91.8417C78.0736 89.8716 78.7292 87.957 79.9397 86.4026C81.1502 84.8483 82.846 83.7438 84.757 83.2649L86.1408 82.9178C86.9614 82.7117 87.8182 82.6953 88.6461 82.8698C89.4741 83.0444 90.2513 83.4053 90.9189 83.9251C91.5866 84.4449 92.1269 85.11 92.4991 85.8699C92.8712 86.6298 93.0653 87.4645 93.0666 88.3107L93.1091 109.011Z"
          fill="white"
          stroke="#2C2C2C"
          strokeWidth="0.893234"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M114.46 103.799L99.4754 107.563L99.4307 87.8669C99.4271 85.8969 100.083 83.9822 101.293 82.4279C102.504 80.8736 104.2 79.769 106.111 79.2901L107.494 78.9431C108.315 78.7371 109.172 78.7207 110 78.8953C110.828 79.0698 111.606 79.4306 112.274 79.9504C112.942 80.4701 113.483 81.1351 113.855 81.895C114.228 82.6548 114.423 83.4896 114.425 84.3359L114.46 103.799Z"
          fill="white"
          stroke="#2C2C2C"
          strokeWidth="0.893234"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M93.0252 72.505L78.0407 76.2683L77.9932 55.3309C77.9896 53.3609 78.6452 51.4462 79.8557 49.8919C81.0663 48.3376 82.7621 47.233 84.673 46.7541L86.0568 46.4071C86.8774 46.201 87.7342 46.1846 88.5622 46.3591C89.3901 46.5336 90.1674 46.8945 90.835 47.4144C91.5026 47.9342 92.043 48.5993 92.4151 49.3592C92.7872 50.1191 92.9813 50.9538 92.9827 51.7999L93.0252 72.505Z"
          fill="white"
          stroke="#2C2C2C"
          strokeWidth="0.893234"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M114.376 67.2891L99.3914 71.0524L99.3467 51.3566C99.3433 49.3871 99.9991 47.4731 101.21 45.9195C102.42 44.366 104.116 43.2623 106.027 42.7843L107.41 42.4372C108.23 42.2321 109.085 42.2161 109.912 42.3906C110.739 42.565 111.515 42.9252 112.182 43.4439C112.849 43.9627 113.389 44.6264 113.761 45.3847C114.134 46.1431 114.329 46.9762 114.332 47.8211L114.376 67.2891Z"
          fill="white"
          stroke="#2C2C2C"
          strokeWidth="0.893234"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M106.82 42.5811L106.881 69.1681"
          stroke="#2C2C2C"
          strokeWidth="0.893234"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M106.879 79.3105L106.939 105.679"
          stroke="#2C2C2C"
          strokeWidth="0.893234"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M106.965 117.479L107.024 143.543"
          stroke="#2C2C2C"
          strokeWidth="0.893234"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M85.4727 46.6221L85.5356 74.3837"
          stroke="#2C2C2C"
          strokeWidth="0.893234"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M85.5547 83.0615L85.6178 110.881"
          stroke="#2C2C2C"
          strokeWidth="0.893234"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M85.6426 121.176L85.7043 148.384"
          stroke="#2C2C2C"
          strokeWidth="0.893234"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_9017_144758">
          <rect
            width="128.693"
            height="173.051"
            fill="white"
            transform="translate(0 0.291992) rotate(-0.13)"
          />
        </clipPath>
      </defs>
    </svg>
  </Container>
);

export default LogePinPoint;
